/* ==========================================================================
   Oil Viscosity Calculator
   Self-contained. Loaded only on this calculator's page.
   No shared dependencies.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.querySelector('[data-pc-ovc]');
  if (!root) return;

  /* Lowest reliable pumping temperature for each winter grade, in Fahrenheit. */
  var W_GRADE = [
    { w: '0W',  minF: -40 },
    { w: '5W',  minF: -25 },
    { w: '10W', minF: -10 },
    { w: '15W', minF: 10 },
    { w: '20W', minF: 20 }
  ];
  var HOT_GRADE = { '16': 20, '20': 20, '30': 30, '40': 40, '50': 50 };

  /* The winter rating each specification normally ships with. The W rating is
     never stepped UP from the manufacturer's figure: a heavier cold grade only
     makes cold starts worse. It is stepped DOWN when the climate is colder
     than the specified grade can pump at. */
  var SPEC_W = { '16': '0W', '20': '5W', '30': '5W', '40': '5W', '50': '15W' };

  /* ====================================================================
     compute(input) -> result

     PURE. No DOM, no network, no globals. All calculator logic lives here
     so it can be reasoned about and tested in isolation.
     ==================================================================== */
  function compute(input) {
    if (!isFinite(input.coldest)) {
      return { ok: false, errors: ['Enter the coldest start temperature.'] };
    }

    /* Start from the winter grade the manufacturer specifies, then step to a
       lighter one only if the climate is colder than that grade can pump at.
       Never step heavier: a higher W number is strictly worse on a cold start. */
    var specW = SPEC_W[input.spec] || '5W';
    var pick = null, specIdx = 0;
    for (var i = 0; i < W_GRADE.length; i++) {
      if (W_GRADE[i].w === specW) { pick = W_GRADE[i]; specIdx = i; break; }
    }
    if (!pick) { pick = W_GRADE[1]; specIdx = 1; }

    var steppedCold = false;
    if (input.coldest < pick.minF) {
      for (var j = specIdx - 1; j >= 0; j--) {
        if (input.coldest >= W_GRADE[j].minF || j === 0) { pick = W_GRADE[j]; steppedCold = true; break; }
      }
    }

    var hot = HOT_GRADE[input.spec] || 30;
    var baseHot = hot;
    var notes = [];

    if (steppedCold) notes.push('Your coldest start is below what ' + specW + ' reliably pumps at, so the winter rating steps lighter.');
    if (input.tow && hot < 50) { hot = hot + 10; notes.push('Heavy load raises oil temperature, so a step up in hot grade holds film strength.'); }
    if (input.high && hot < 50) { hot = hot + 10; notes.push('A worn engine with larger clearances often runs better on a slightly heavier grade.'); }
    if (isFinite(input.hottest) && input.hottest >= 105 && hot < 50) { hot = hot + 10; notes.push('Sustained high ambient temperature is another reason to step up.'); }
    if (hot > 50) hot = 50;

    var grade = pick.w + '-' + hot;
    var specGrade = specW + '-' + baseHot;

    var status, warnings = [];
    if (input.spec === '16' && hot > 20) {
      status = { key: 'now', label: 'Use the specified grade',
                 note: 'Modern engines specified for 0W-16 or 0W-20 have tight oil galleries and variable valve timing that depend on that viscosity. Do not go heavier.' };
      warnings.push('On an engine designed around 0W-16 or 0W-20, a heavier oil can slow variable valve timing actuators enough to set a fault, and it reduces flow where the engine needs it most.');
      grade = specGrade;
    } else if (hot !== baseHot) {
      status = { key: 'monitor', label: grade,
                 note: 'A step up from the specified ' + specGrade + ' for the conditions you described. Only do this if the manufacturer lists it as acceptable.' };
    } else {
      status = { key: 'good', label: grade,
                 note: 'Matches the manufacturer specification and suits your climate.' };
    }

    var rows = [
      { head: 'Suggested' },
      { label: 'Grade', value: grade },
      { label: 'Manufacturer spec', value: specGrade },
      { label: 'Winter rating', value: pick.w + ', pumps to about ' + num(pick.minF, 0) + 'F' },
      { label: 'Hot rating', value: String(hot) },
      { head: 'Winter grades' }
    ];
    W_GRADE.forEach(function (g) {
      rows.push({ label: g.w + (g.w === pick.w ? '  (yours)' : ''), value: 'down to about ' + num(g.minF, 0) + ' F' });
    });
    if (notes.length) {
      rows.push({ head: 'Why it was adjusted' });
      notes.forEach(function (n, i) { rows.push({ label: 'Reason ' + (i + 1), value: n }); });
    }

    return {
      ok: true, errors: [], warnings: warnings, status: status,
      figures: [
        { label: 'Suggested grade', value: grade,
          sub: 'Manufacturer specifies ' + specGrade + '. Their figure always takes priority.' },
        { label: 'Cold start capability', value: 'about ' + num(pick.minF, 0) + ' F',
          sub: 'The ' + pick.w + ' rating is about how the oil flows when cold, not how thick it is when hot.' }
      ],
      rows: rows
    };
  }

  /* ====================================================================
     Formatting
     ==================================================================== */
  function comma(n) {
    return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function num(n, dp) {
    if (!isFinite(n)) return '-';
    var v = Number(n).toFixed(dp == null ? 2 : dp);
    if (dp !== 0 && v.indexOf('.') > -1) v = v.replace(/\.?0+$/, '');
    var parts = v.split('.');
    return comma(parts[0]) + (parts[1] ? '.' + parts[1] : '');
  }

  function signed(n, dp) {
    if (!isFinite(n)) return '-';
    return (n > 0 ? '+' : '') + num(n, dp);
  }

  /* ====================================================================
     DOM wiring
     ==================================================================== */
  var FIELDS = [
      {
          "name": "coldest",
          "key": "c",
          "type": "number"
      },
      {
          "name": "hottest",
          "key": "h",
          "type": "number"
      },
      {
          "name": "spec",
          "key": "s",
          "type": "select"
      },
      {
          "name": "tow",
          "key": "t",
          "type": "checkbox"
      },
      {
          "name": "high",
          "key": "hm",
          "type": "checkbox"
      }
  ];

  var els = {
    error:    root.querySelector('[data-r-error]'),
    status:   root.querySelector('[data-r-status]'),
    statusLbl:root.querySelector('[data-r-status-label]'),
    statusVal:root.querySelector('[data-r-status-value]'),
    statusNote:root.querySelector('[data-r-status-note]'),
    figures:  root.querySelector('[data-r-figures]'),
    rows:     root.querySelector('[data-r-rows]'),
    warnings: root.querySelector('[data-r-warnings]')
  };

  var STATUS_CLASSES = ['is-good','is-monitor','is-soon','is-now','is-critical'];

  function field(name) { return root.querySelector('[data-f="' + name + '"]'); }

  function readInput() {
    var o = {};
    FIELDS.forEach(function (f) {
      var el = field(f.name);
      if (!el) return;
      if (f.type === 'checkbox') o[f.name] = el.checked;
      else if (f.type === 'number') o[f.name] = parseFloat(el.value);
      else o[f.name] = el.value;
    });
    return o;
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
  }

  function renderFigures(figs) {
    els.figures.innerHTML = (figs || []).map(function (f) {
      return '<div class="pc-ovc__figure">'
        + '<div class="pc-ovc__figure-label">' + esc(f.label) + '</div>'
        + '<div class="pc-ovc__figure-value' + (f.muted ? ' is-muted' : '') + '">'
        + esc(f.value) + '</div>'
        + (f.sub ? '<div class="pc-ovc__figure-sub">' + esc(f.sub) + '</div>' : '')
        + '</div>';
    }).join('');
  }

  function renderRows(rows) {
    if (!els.rows) return;
    els.rows.innerHTML = (rows || []).map(function (r) {
      if (r.head) {
        return '<div class="pc-ovc__row pc-ovc__rows-head">' + esc(r.head) + '</div>';
      }
      return '<div class="pc-ovc__row">'
        + '<span class="pc-ovc__row-label">' + esc(r.label) + '</span>'
        + '<span class="pc-ovc__row-value">' + esc(r.value) + '</span>'
        + '</div>';
    }).join('');
  }

  function clearResult(message) {
    if (els.status) {
      STATUS_CLASSES.forEach(function (c) { els.status.classList.remove(c); });
      els.statusVal.textContent  = 'Waiting for your numbers';
      els.statusNote.textContent = message || '';
    }
    els.figures.innerHTML = '';
    if (els.rows) els.rows.innerHTML = '';
    if (els.warnings) els.warnings.style.display = 'none';
  }

  function render() {
    var input  = readInput();
    var result = compute(input);

    if (!result.ok) {
      els.error.textContent = result.errors[0];
      els.error.classList.add('is-shown');
      clearResult(result.errors[0]);
      return;
    }
    els.error.classList.remove('is-shown');

    if (els.status) {
      STATUS_CLASSES.forEach(function (c) { els.status.classList.remove(c); });
      if (result.status) {
        els.status.classList.add('is-' + result.status.key);
        els.statusVal.textContent  = result.status.label;
        els.statusNote.textContent = result.status.note || '';
      } else {
        els.statusVal.textContent  = '';
        els.statusNote.textContent = '';
      }
    }

    renderFigures(result.figures);
    renderRows(result.rows);

    if (els.warnings) {
      if (result.warnings && result.warnings.length) {
        els.warnings.textContent = result.warnings[0];
        els.warnings.style.display = '';
      } else {
        els.warnings.style.display = 'none';
      }
    }

    writePermalink(input);
  }

  /* ====================================================================
     Shareable result permalinks
     ==================================================================== */
  function writePermalink(input) {
    if (!window.history || !window.history.replaceState) return;
    var q = FIELDS.map(function (f) {
      var v = input[f.name];
      if (f.type === 'checkbox') return v ? f.key + '=1' : '';
      if (v == null || v !== v || v === '') return '';
      return f.key + '=' + encodeURIComponent(v);
    }).filter(Boolean).join('&');
    try {
      window.history.replaceState(null, '', window.location.pathname + (q ? '?' + q : ''));
    } catch (e) {}
  }

  function applyPermalink() {
    if (!window.URLSearchParams) return;
    var p = new URLSearchParams(window.location.search);
    var any = false;
    FIELDS.forEach(function (f) {
      if (!p.has(f.key)) return;
      var el = field(f.name);
      if (!el) return;
      if (f.type === 'checkbox') el.checked = p.get(f.key) === '1';
      else el.value = p.get(f.key);
      any = true;
    });
    return any;
  }

  /* ====================================================================
     Init
     ==================================================================== */
  ['input', 'change'].forEach(function (evt) {
    root.addEventListener(evt, function (e) {
      if (e.target.closest('[data-r-form]')) render();
    });
  });

  applyPermalink();
  render();

  /* Exposed for testing and debugging only. */
  window.PC_OVC = { compute: compute };
})();
